import {makeStyles} from "@material-ui/core/styles";

export const useDefaultLayoutStyles = makeStyles((theme) => ({
    main: {
        marginTop: "57px",
        marginLeft: 0,
        padding: "2em",
        [theme.breakpoints.up('sm')]: {
            marginTop: "80px",
            marginLeft: "240px"
        },
    },
}));
